import { IJobApplicationFields } from '../../pages/Dashboard/JobApplications/JobApplicationFormModal'
import apiService from '../Api'
import { JobApplication, JobApplicationComplete, JobApplicationPositions, JobApplicationStatuses } from './types'

export class JobApplicationService {
  async list(queryParams: {
    search: string
    length: string
    page: number
    status: string
    position: string
    area: string
  }): Promise<{ data: JobApplication[]; recordsFiltered: number; recordsTotal: number }> {
    const params = new URLSearchParams()
    params.append('search', queryParams.search)
    params.append('length', queryParams.length)
    params.append('start', ((queryParams.page - 1) * parseInt(queryParams.length)).toString())
    params.append('status', queryParams.status)
    params.append('job_position', queryParams.position)
    params.append('area', queryParams.area)

    return apiService.get('/job-application', { params }).then((response) => response.data)
  }

  async positions(): Promise<JobApplicationPositions> {
    return apiService.get('/job-application/positions').then((response) => response.data)
  }

  async get(id: number): Promise<JobApplicationComplete> {
    return apiService.get(`/job-application/${id}`).then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/job-application/${id}`)
  }

  async updateStatus(id: number, newStatus: JobApplicationStatuses): Promise<void> {
    return apiService.post(`/job-application/change-status/${id}/${newStatus}`)
  }

  async create(form: IJobApplicationFields): Promise<JobApplicationComplete> {
    const formData = new FormData()
    formData.append('name', form.name)
    formData.append('email', form.email)
    formData.append('phone', form.phone)
    formData.append('position', form.position)
    formData.append('status', form.status)
    form.area.forEach((area) => {
      formData.append('area[]', area)
    })
    formData.append('why_you_want_to_work_here', form.why_you_want_to_work_here)
    formData.append('reasons_to_hire_you', form.reasons_to_hire_you)
    if (form.resume) {
      formData.append('resume', form.resume)
    }

    return apiService.post('/job-application', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async update(id: number, form: IJobApplicationFields): Promise<JobApplicationComplete> {
    const formData = new FormData()
    formData.append('_method', 'PUT')
    formData.append('name', form.name)
    formData.append('email', form.email)
    formData.append('phone', form.phone)
    formData.append('status', form.status)
    formData.append('job_position', form.position)
    if (form.area) {
      form.area.forEach((area) => {
        formData.append('area[]', area)
      })
    }
    formData.append('why_you_want_to_work_here', form.why_you_want_to_work_here)
    formData.append('reasons_to_hire_you', form.reasons_to_hire_you)
    if (form.resume) {
      formData.append('resume', form.resume)
    }
    return apiService.post(`/job-application/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
